export default __webpack_public_path__ + "static/media/Leg Lower Left.e669b78e.jpg";